/**
 * main.jsx
 * Entry point. Mounts the app inside the router and the shared providers.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { BrandProvider } from './hooks/useBrands.jsx';
import { SessionProvider } from './hooks/useSession.jsx';
import './styles/theme.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/screens.css';
import './styles/dashboard.css';
import './styles/breakdown.css';
import './styles/copilot.css';
import './styles/inbox.css';
import './styles/predictor.css';
import './styles/listening.css';
import './styles/repurpose.css';
import './styles/features.css';
import './styles/video.css';
import './styles/website.css';
// Last, so the phone layout overrides the desktop rules above.
import './styles/mobile.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <BrandProvider>
          <App />
        </BrandProvider>
      </SessionProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
